module.exports = __webpack_public_path__ + "img/相続のせんせい.df08db6d.png";